//
export default [
    {
        name: 'rut',
        type: 'rut-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Rut',
        },
    },
    {
        name: 'alias_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Nombre fantasía',
        },
    },
    {
        name: 'business_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg5: true,
        },
        props: {
            label: 'Razón social',
        },
    },
    {
        name: 'core_business',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Giro',
        },
    },
    {
        name: 'email_collection',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Correo electrónico',
        },
    },
    /*{
        name: 'branch_offices',
        type: 'table-field',
        flex: {
            'd-grid': true,
            xs12: true,
        },
        props: {
            headers: [
                {
                    text: '#',
                    value: 'id',
                },
                {
                    text: 'dirección',
                    value: 'address',
                },
                {
                    text: 'ciudad',
                    value: 'city',
                },
                {
                    text: 'correo electrónico',
                    value: 'email',
                },
                {
                    text: 'teléfono',
                    value: 'phone',
                },
            ],
            noRefresh: true,
            toolbarTitle: 'Sucursales',
        },
    },*/
]
